// src/services/postcodeService.js
import qs from "qs";

const ENDPOINT = "https://api.mapbox.com/geocoding/v5/mapbox.places";
const TOKEN = import.meta.env?.VITE_MAPBOX_TOKEN || "pk.eyJ1Ijoic29jaXVzYXBwcyIsImEiOiJjbWJ1bngwY2kwZGl6MmpzMGlzeXo4cGg5In0.KMzxXacEobQJEQKGyhOspA";
/* simple RAM cache to avoid duplicate hits */
const cache = new Map();

/**
 * Query Mapbox Places for postal-code suggestions.
 *
 * @param {string} query     what the user is typing
 * @param {string[]} isoArr  ISO-2 country codes selected in the zone
 * @returns {Promise<Array<{value:string, iso:string, label:string}>>}
 */
export async function searchPostcodes(query, isoArr) {
  if (!query || isoArr.length === 0) return [];

  /* Mapbox lets us send multiple country codes comma-separated.
     We'll cap at 10 to keep URL size reasonable. */
  const countries = isoArr.slice(0, 10).join(",");
  const cacheKey = `${countries}|${query}`;

  if (cache.has(cacheKey)) return cache.get(cacheKey);

  const url =
    `${ENDPOINT}/${encodeURIComponent(query)}.json?` +
    qs.stringify({
      types: "postcode",
      autocomplete: "true",
      country: countries,
      limit: 10,
      access_token: TOKEN,
    });

  const res = await fetch(url);
  if (!res.ok) return [];

  const data = await res.json();
  const options =
    (data.features || []).map((f) => ({
      value: f.text,                          // "90210"
      iso: (f.context || []).find((c) => c.id.startsWith("country"))?.short_code?.toUpperCase() || "",
      label:
        `${f.text} (` +
        `${
          (f.context || []).find((c) => c.id.startsWith("country"))?.short_code?.toUpperCase() ||
          "??"
        })`,
    })) || [];

  cache.set(cacheKey, options);
  return options;
}
